import { rollbackJourney } from './io';
import { Promise } from 'es6-promise';
import types from '../store/types';
import store from '../store/store';
import { IdHelper, IJourneyItem, IAdminToolPanel, AdminToolPanelHelper, UpgradeHelper, AdminToolHelper } from './';
declare var jQuery;

export class JourneyRollbackHelper {


    /**
    *  Start the journey rollback process.
    *  This method calls CallRollback method for every
    *  process item.
    * @static
    * @memberOf JourneyRollbackHelper
    **/
    public static StartUpRollbackProcess(processList:any, ) {
        let getState: any = store.getState();
        let journeyId: string = getState.adminToolState.processList[getState.adminToolState.tab][0].journeyId;
        let rollbackToUpgradeId: string = getState.adminToolState.processList[getState.adminToolState.tab][0].upgradeId;
        AdminToolHelper.SetUpgradingProcess(true, journeyId, 0);
        JourneyRollbackHelper.CallRollback(rollbackToUpgradeId, journeyId, getState.adminToolState.UpgradeId, (processList[getState.adminToolState.tab].length == 1));
        AdminToolHelper.GetLoggingFor(journeyId, getState.adminToolState.UpgradeId, getState.adminToolState.advancedLogging);
    }
    /**
    *  Calls the rollback API and set 'isprocessing' to true in the state
    * @static
    * @memberOf JourneyRollbackHelper
    **/
    public static CallRollback(rollbackUpgradeId:any, journeyId:any, upgradeId:string, isFinalRequest:boolean) {
        let promise = new Promise<any>((resolve, reject) => {
            rollbackJourney(rollbackUpgradeId, journeyId, upgradeId, isFinalRequest).then(
                (response) => {
                    let getState: any = store.getState();

                    AdminToolHelper.UpdateProcessItem(getState.adminToolState.journeyProcessNum, (response.isValid ? "Success" : "Failed"));
                    if ((getState.adminToolState.journeyProcessNum + 1) < getState.adminToolState.processList[getState.adminToolState.tab].length && !getState.adminToolState.cancelUpgrade) {
                        let journeyNum: number = getState.adminToolState.journeyProcessNum + 1;
                        let journeyId: string = getState.adminToolState.processList[getState.adminToolState.tab][journeyNum].journeyId;
                        let rollbackToUpgradeId: string = getState.adminToolState.processList[getState.adminToolState.tab][journeyNum].upgradeId;
                        AdminToolHelper.SetUpgradingProcess(true, journeyId, journeyNum);
                        JourneyRollbackHelper.CallRollback(rollbackToUpgradeId, journeyId, upgradeId, ((journeyNum + 1) == getState.adminToolState.processList[getState.adminToolState.tab].length));
                    }
                    else {
                        if (getState.adminToolState.cancelUpgrade) {
                            UpgradeHelper.CancelUpgrade(getState.adminToolState.UpgradeId);
                        }
                        setTimeout(() => {
                            AdminToolHelper.SetUpgradingProcess(false, "", 0);
                        }, 1000);
                    }
                },
                (error) => {
                    reject(error);
                }
            );
        });
    }
}


// WEBPACK FOOTER //
// ./source/ts/helpers/journeyrollbackhelper.ts